import { useViewerContext } from '../ViewerContext';
import { ViewFilter } from './ViewFilter';
import { ViewGroupsFilter } from './ViewGroupsFilter';
import styles from './ViewerFilterBar.module.css';

/**
 * Left side of the viewer control row (AP-441): the searchable View Filter and
 * the clinical View Group selector. Both read/write the shared filter state on
 * ViewerContext so they drive the grid and the filmstrip together.
 */
export function ViewerFilterBar() {
  const {
    availableViews,
    selectedViews,
    setSelectedViews,
    selectedGroupId,
    setSelectedGroupId,
  } = useViewerContext();

  return (
    <div className={styles.bar}>
      <ViewFilter
        options={availableViews}
        selected={selectedViews}
        onChange={setSelectedViews}
      />
      <ViewGroupsFilter value={selectedGroupId} onChange={setSelectedGroupId} />
    </div>
  );
}
